module.exports = __webpack_public_path__ + "static/media/dark-wave.6b0ea0ee.svg";